import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";

import { MedIconDotFillComponent } from "./med-icon-dot-fill.component";

@NgModule({
  declarations: [
    MedIconDotFillComponent,
  ],
  imports: [
    CommonModule,
  ],
  exports: [
    MedIconDotFillComponent,
  ],
})
export class MedIconDotFillModule { }
